import React, { useContext } from "react";
import GlobalContext from "../../context/GlobalContext";
import "../../assets/css/loadingComponent.css"; // Tambahkan file CSS khusus untuk styling

const LoadingComponent = () => {
    const { isLoading } = useContext(GlobalContext);

    return (
        isLoading && (
            <div className="custom-loading-overlay">
                <div className="custom-loading-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        )
    );
};

export default LoadingComponent;